import { render, staticRenderFns } from "./CurtainsDevice.vue?vue&type=template&id=ba14c7da&scoped=true&"
import script from "./CurtainsDevice.vue?vue&type=script&lang=js&"
export * from "./CurtainsDevice.vue?vue&type=script&lang=js&"
import style0 from "./CurtainsDevice.vue?vue&type=style&index=0&id=ba14c7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba14c7da",
  null
  
)

export default component.exports